import React from 'react';

const CalendarOrangeV2 = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("rect", { width: "48", height: "48", rx: "24", fill: "#FF7400", fillOpacity: "0.12" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M28.7502 15.56V14C28.7502 13.59 28.4102 13.25 28.0002 13.25C27.5902 13.25 27.2502 13.59 27.2502 14V15.5H20.7502V14C20.7502 13.59 20.4102 13.25 20.0002 13.25C19.5902 13.25 19.2502 13.59 19.2502 14V15.56C16.5502 15.81 15.2402 17.42 15.0402 19.81C15.0202 20.1 15.2602 20.34 15.5402 20.34H32.4602C32.7502 20.34 32.9902 20.09 32.9602 19.81C32.7602 17.42 31.4502 15.81 28.7502 15.56Z",
      fill: "#FF7400"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M31 27C28.79 27 27 28.79 27 31C27 31.75 27.21 32.46 27.58 33.06C28.27 34.22 29.54 35 31 35C32.46 35 33.73 34.22 34.42 33.06C34.79 32.46 35 31.75 35 31C35 28.79 33.21 27 31 27ZM33.07 30.57L30.94 32.54C30.8 32.67 30.61 32.74 30.43 32.74C30.24 32.74 30.05 32.67 29.9 32.52L28.91 31.53C28.62 31.24 28.62 30.76 28.91 30.47C29.2 30.18 29.68 30.18 29.97 30.47L30.45 30.95L32.05 29.47C32.35 29.19 32.83 29.21 33.11 29.51C33.39 29.81 33.37 30.28 33.07 30.57Z",
      fill: "#FF7400"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M32 21.8398H16C15.45 21.8398 15 22.2898 15 22.8398V28.9998C15 31.9998 16.5 33.9998 20 33.9998H24.93C25.62 33.9998 26.1 33.3298 25.88 32.6798C25.68 32.0998 25.51 31.4598 25.51 30.9998C25.51 27.9698 27.98 25.4998 31.01 25.4998C31.3 25.4998 31.59 25.5198 31.87 25.5698C32.47 25.6598 33.01 25.1898 33.01 24.5898V22.8498C33 22.2898 32.55 21.8398 32 21.8398ZM21.21 30.2098C21.02 30.3898 20.76 30.4998 20.5 30.4998C20.24 30.4998 19.98 30.3898 19.79 30.2098C19.61 30.0198 19.5 29.7598 19.5 29.4998C19.5 29.2398 19.61 28.9798 19.79 28.7898C19.89 28.6998 19.99 28.6298 20.12 28.5798C20.49 28.4198 20.93 28.5098 21.21 28.7898C21.39 28.9798 21.5 29.2398 21.5 29.4998C21.5 29.7598 21.39 30.0198 21.21 30.2098ZM21.21 26.7098C21.16 26.7498 21.11 26.7898 21.06 26.8298C21 26.8698 20.94 26.8998 20.88 26.9198C20.82 26.9498 20.76 26.9698 20.7 26.9798C20.63 26.9898 20.56 26.9998 20.5 26.9998C20.24 26.9998 19.98 26.8898 19.79 26.7098C19.61 26.5198 19.5 26.2598 19.5 25.9998C19.5 25.7398 19.61 25.4798 19.79 25.2898C20.02 25.0598 20.37 24.9498 20.7 25.0198C20.76 25.0298 20.82 25.0498 20.88 25.0798C20.94 25.0998 21 25.1298 21.06 25.1698C21.11 25.2098 21.16 25.2498 21.21 25.2898C21.39 25.4798 21.5 25.7398 21.5 25.9998C21.5 26.2598 21.39 26.5198 21.21 26.7098ZM24.71 26.7098C24.52 26.8898 24.26 26.9998 24 26.9998C23.74 26.9998 23.48 26.8898 23.29 26.7098C23.11 26.5198 23 26.2598 23 25.9998C23 25.7398 23.11 25.4798 23.29 25.2898C23.67 24.9198 24.34 24.9198 24.71 25.2898C24.89 25.4798 25 25.7398 25 25.9998C25 26.2598 24.89 26.5198 24.71 26.7098Z",
      fill: "#FF7400"
    }
  )
);
CalendarOrangeV2.displayName = "Icons.CalendarOrangeV2";

export { CalendarOrangeV2 };
//# sourceMappingURL=CalendarOrangeV2.js.map
